import {
  STATUS_BOOKING,
  STATUS_BOOKINGS_NAMES,
} from "@/constants/status-booking";
import {
  STATUS_PRIVATE_OFFICE,
  STATUS_PRIVATE_OFFICE_NAMES,
  STATUS_PRIVATE_OFFICE_UPDATED_DAYS,
  STATUS_PRIVATE_OFFICE_UPDATED_DAYS_NAMES,
} from "@/constants/status-private-office";

import {
  ConvertStatusByIdProps,
  STATUS_NAME_TYPE,
} from "./convert-status-to-name.types";

type StatusEnum = Record<string, string | number>;
type StatusNames = Record<string, STATUS_NAME_TYPE>;

export const ConvertStatusById = ({ status, type }: ConvertStatusByIdProps) => {
  let statusType: StatusEnum = {};
  let statusTypeNames: StatusNames = {};

  switch (type) {
    case "STATUS_BOOKINGS":
      statusType = STATUS_BOOKING as unknown as StatusEnum;
      statusTypeNames = STATUS_BOOKINGS_NAMES as unknown as StatusNames;
      break;
    case "STATUS_PRIVATE_OFFICE":
      statusType = STATUS_PRIVATE_OFFICE as unknown as StatusEnum;
      statusTypeNames = STATUS_PRIVATE_OFFICE_NAMES as unknown as StatusNames;
      break;
    case "STATUS_PRIVATE_OFFICE_UPDATED_DAYS":
      statusType = STATUS_PRIVATE_OFFICE_UPDATED_DAYS as unknown as StatusEnum;
      statusTypeNames =
        STATUS_PRIVATE_OFFICE_UPDATED_DAYS_NAMES as unknown as StatusNames;
      break;
    default:
      break;
  }
  const CURRENT_STATUS_KEY =
    Object.keys(statusType).find(
      (key) => String(statusType[key]) === String(status),
    ) || null;

  const CURRENT_STATUS =
    Object.entries(statusTypeNames).find(
      (item) => item[0] === CURRENT_STATUS_KEY,
    ) || "";

  const CURRENT_STATUS_BADGE = CURRENT_STATUS[1] as STATUS_NAME_TYPE;

  return CURRENT_STATUS_BADGE;
};
